<div class="text-right h3 btn btn-primary float-left"><span class="fa fa-download" (click)="exportReport()" title="Download Excel"></span></div>
<table style="table-layout: fixed; width: 100%;" class="table table-xs tableFixHead" id="live-asset-report" *ngIf="reportService.reportData.length > 0">
    <thead>
        <tr>
            <th>ID</th>
            <th>{{ level_info?.second_level_name?level_info?.second_level_name:'DSM' }} Name</th>
            <th>{{ level_info?.third_level_name?level_info?.third_level_name:'ASM' }} Name</th>
            <th [hidden]="_wssp_ids_based">District</th>
            <th [hidden]="_wssp_ids_based">City</th>
            <th [hidden]="_wssp_ids_based">{{ level_info?.fourth_level_name?level_info?.fourth_level_name:'Distribution' }}</th>
            <th>Vehicle No</th>
            <th>Vehicle Type</th>
            <th>No. Of Live Vehicle</th>
            <th>Last Reporting Date/Time</th>
            <th>Last Location</th>
        </tr>
    </thead>
    <tbody>
        <tr class="table-border-double" *ngFor="let live of reportService.reportData; let i=index" [ngStyle]="{'background-color': live.row_color, 'color':live.font_color}">
            <td>{{ live.level1 }}</td>
            <td>{{ live.level2 }}</td>
            <td>{{ live.level3 }}</td>
            <td [hidden]="_wssp_ids_based">{{ live.state }}&nbsp;</td>
            <td [hidden]="_wssp_ids_based">{{ live.city }}&nbsp;</td>
            <td [hidden]="_wssp_ids_based">{{ live.level4 }}</td>
            <td>{{ live.plate_no }}</td>
            <td>{{ live.vehicle_model }}</td>
            <td>{{ live.no_live_vehicles }}</td>
            <td *ngIf="live.receiving_date_time">{{ live.receiving_date_time | date: 'dd/MM/yyyy hh:mm:ss a' }}</td>
            <td *ngIf="!live.receiving_date_time"></td>
            <td>{{ live.last_location }}</td>
        </tr>
    </tbody>
</table>
